<template lang="html">
  <div class="wrapper">
    <load-spinner v-if="showSpinner"></load-spinner>
    <b-modal ref="req-result">
      <p class="my-4"
         v-bind:class="{ 'message-success' : this.reqSuccess, 'message-fail': !this.reqSuccess } ">{{
          reqResult
        }}</p>
    </b-modal>

    <div class="buttons">

    </div>

    <b-tabs content-class="mt-3">
      <b-tab title="Коефіцієнт бонусів">
        <label>Бонуси, що нараховуються за куплене паливо (за 1 л). Наприклад 0.05 гривень за кожен куплений літр палива через чат бот.</label>
        <b-form-input v-model="k" @focusout="setK"></b-form-input>
      </b-tab>
      <b-tab title="Синхронізувати менеджерів">
        <label>Натискання цієї кнопки дозволяє примусово виконати синхронізацію даних менеджерів та компаній, за якими вони закріплені, з CRM. Також у процесі синхронізації буде встановлено зв’язки між менеджерами та клієнтами якщо вони передбачені у CRM, але були відсутні у чат-боті до синхронізації. Синхронізація виконується автоматично за графіком кожну годину о 00 хвилин.</label></br>
        <b-button variant="outline-success" @click="sync">
          Синхронізувати
        </b-button>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script lang="js">
import LoadSpinner from '@/components/LoadSpinner';
import {getK, setK} from "@/services/Stats.service";
import {getManagers, syncManagers} from "@/services/Managers.service";

export default {
  name: 'src-components-options',
  props: [],
  components: {LoadSpinner},
  mounted() {
    this.getK();
  },
  data() {
    return {
      ready: true,
      showSpinner: false,
      k: 0,

      reqSuccess: true,
      reqResult: '',
    }
  },
  methods: {
    showModal() {
      this.$refs['req-result'].show();
      setTimeout(() => {
        this.$refs['req-result'].hide();
      }, 2000);
    },
    sync() {
      this.showSpinner = true;
      syncManagers()
          .then(() => {
            return getManagers()
          })
          .then((managers) => {
            this.items = managers.map(manager => {
              return {
                id: manager['id'],
                'Ім\'я': manager['name'],
                name: manager['name'],
                'Телефон': manager['phone'],
                phone: manager['phone'],
              }
            }).sort((a, b) => a - b);
            this.reload = false;
            this.original = JSON.parse(JSON.stringify(this.items))
            this.showSpinner = false;
            this.reload = true;
            this.reqSuccess = true;
          })
          .catch((err) => {
            this.showSpinner = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          })
    },
    async getK() {
      this.ready = false;
      this.showSpinner = true;
      try {
        this.k = await getK()
        this.reqSuccess = true;
      } catch (err) {
        this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
        this.reqSuccess = false;
        this.showModal();
      }
      this.showSpinner = false;
      this.ready = true;
    },
    async setK() {
      this.k = +(this.k.replace(',', '.'));
      if (isNaN(this.k)) {
        this.k = 0.05;
      }
      this.ready = false;
      this.showSpinner = true;
      try {
        await setK(this.k);
        this.reqResult = 'Дані змінені';
        this.reqSuccess = true;
      } catch (err) {
        this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
        this.reqSuccess = false;
      }
      this.showModal();
      this.showSpinner = false;
      this.ready = true;
    }
  },
  computed: {}
}
</script>

<style lang="scss">

.wrapper {
  padding: 16px 32px;

}

.message-fail {
  color: red !important;
}

.message-success {
  color: green;
}

.buttons {
  margin-bottom: 48px;
}
</style>
